// extracted by mini-css-extract-plugin
export var info = "style-module--info--9daa6";
export var program = "style-module--program--f8c90";
export var resultBlock = "style-module--result-block--b4f50";